<template>

  <div id="header" :class="{ true: isShowing }">

    <div id="menuBtn" class="navTitles txtWhite" @click="openMenu" :class="{ true: isShowing }">
        <div id="menuIcon" class="roundBtn">
          <div class="wrap">
            <span></span><span></span><span></span>
          </div>
        </div>
      <span class="title">Menu</span>
    </div>

    <div id="bsdBtn" class="navTitles txtWhite">
      <div id="bsdIcon">
        <div class="icon">
          <!-- Contact - say hi -->
          <router-link to="/">
            <img class="contact hideMe" src="../../assets/icons/bsd_icon.svg" alt="Hi, we're Blacksheepdesign" title="Hi, we're Blacksheepdesign" />
          </router-link>
        </div>
      </div>
      <router-link to="/">
        <span id="bsdText" style="color: white;">Blacksheepdesign</span>
      </router-link>
    </div>

    <div id="movingHeader" class="header" :class="{ true: isShowing }">

      <!--  Menu Menu Menu -->
      <div class="navigation" :class="{ true: isShowing }">

        <div id="innerSlider" class="clearfix">

          <ul id="menu" class="txtWhite">
            <li v-if="this.$route.name == 'Home'"><a v-on:click="scrollTo('ourwork')" class="txtWhite">Neat Stuff</a></li>
            <li v-else><router-link to="/#ourwork">Neat Stuff</router-link></li>
            <!-- li @click="loadNewPage"><router-link to="/theflock" >The flock</router-link></li> -->
            <li><router-link to="/theflock" >The Flock</router-link></li>
            <li><router-link to="/services" >Our Services</router-link></li>
            <!-- <li><router-link to="/nutshell">In a nutshell</router-link></li> -->
            <li class="contact" @click="openContact" onclick="ga('send', 'event', 'Contact Menu Btn', 'Click');">
              <img height="1" width="1" style="display:none;" alt="" src="https://dc.ads.linkedin.com/collect/?pid=996412&conversionId=779524&fmt=gifhttps://dc.ads.linkedin.com/collect/?pid=996412&conversionId=779524&fmt=gif"/>
              <span>Contact</span>
            </li>
          </ul>

          <!-- Contact details which slide in on click -->
          <div id="contact" class="" itemscope itemtype="http://schema.org/Organization">

            <div class="contactDetails contact_col" itemscope itemtype="https://schema.org/LocalBusiness">
              <div class="contact_col_row">
                <h3 v-if="mobileClass === 'deviceActive'" itemprop="telephone"><a :href="'tel:' +phone">{{phone}}</a></h3>
                <h3 v-else itemprop="telephone">{{phone}}</h3>
                <h3 itemprop="email"><a :href="'mailto:'+email" onclick="ga('send', 'event', 'BSD Email', 'Click');">{{email}}</a></h3>
              </div>
              <div class="contact_col_row last">
                <div class="contact_col_row_col" v-html="address" itemprop="address">
                 <!--  Address here ^ -->
                </div>
                <div class="contact_col_row_col right">
                  <!-- ORIGINAL PLACE FOR SOCIAL MEDIA //
                       UNCOMMENT WHEN FORMS ARE PUT IN   -->
                 <!-- <p><icon name="facebook-square"></icon> <a :href="facebook" target="_blank" class="txtWhite">facebook</a></p>
                 <p><icon name="instagram"></icon> <a :href="instagram" target="_blank" class="txtWhite">instagram</a></p> -->
                </div>
              </div>
            </div>

            <div class="contactUs contact_col right">
              <!-- ORIGINAL PLACE FOR FIRST TIME CONTACT //
                   UNCOMMENT THIS AND REMOVE THE SOCIAL MEDIA BELOW TO IT'S ORIGINAL PLACE  -->
              <!-- <div class="contact_col_row">
                <p>Are we the right fit?</p>
                <p>First time contact</p>
              </div> -->
              <div class="contact_col_row ">
                <p>Already know who to talk to?</p>
                <p @click="closeMenu2" onclick="ga('send', 'event', 'Manager Details Button', 'Click');"><router-link to="/theflock">Manager contact details</router-link></p>
              </div>
              <div class="contact_col_row">
                <p><icon name="facebook-square"></icon> <a :href="facebook" target="_blank" class="txtWhite" onclick="ga('send', 'event', 'Social', 'Facebook');">Facebook</a></p>
                <p><icon name="instagram"></icon> <a :href="instagram" target="_blank" class="txtWhite" onclick="ga('send', 'event', 'Social', 'Instagram');">Instagram</a></p>
              </div>
            </div>

          </div> <!-- Close Contact -->

        </div>

      </div> <!-- Close Navigation -->

    </div>

  </div> <!-- Close Header -->

</template>

<script>

import menuTransitions from '../../assets/js/menu.js'
import Icon from 'vue-awesome/components/Icon'
import animateScrollTo from 'animated-scroll-to'
import Axios from 'axios'

export default {
  data () {
    return {
      isShowing: false,
      phone: '',
      email: '',
      address: '',
      facebook: '',
      instagram: '',
      mobileClass: ''
    }
  },
  methods: {
    mobileDetect () {
      var browserSize = window.innerWidth || document.body.clientWidth
      var deviceMaxSize = 1024
      if (browserSize < deviceMaxSize) {
        // console.log('tablet down')
        this.mobileClass = 'deviceActive'
      } else {
        // console.log('desktop')
        this.mobileClass = 'desktopActive'
      }
    },
    openMenu (done) { // open up the menu
      var appWrapper = document.body
      var el = document.getElementById('menuIcon')
      var menuBtn = document.getElementById('menuBtn')
      if (el.classList.contains('back') || menuBtn.classList.contains('contactOpen')) {
        menuTransitions.openMenu(el, done)
      } else {
        document.getElementById('movingHeader').classList.toggle('true')
        document.getElementById('menuBtn').classList.toggle('true')
        document.getElementById('curtain').classList.toggle('true')
        var generalWrap = document.getElementById('wrap')
        document.getElementById('header').classList.toggle('true')
        generalWrap.classList.toggle('true')
        var bodyStyle = appWrapper.style.overflow
        var linodes = document.getElementById('menu').childNodes
        for (var a = 0; a < linodes.length; a++) {
          if (linodes[a].textContent !== ' ') {
            linodes[a].classList.toggle('fadeIn')
          }
        }
        // console.log('read..' + bodyStyle)
        if (bodyStyle === 'hidden') {
          appWrapper.style.overflowY = 'scroll'
        } else {
          appWrapper.style.overflow = 'hidden'
        }
      }
    },
    closePopup () {
      // document.getElementById('popupCovid').classList.remove('open')
    },
    loadNewPage () {
      // console.log('loading these styles')
      // var menuBtn = document.getElementById('menuBtn')
      // var appWrapper = document.body
      document.getElementById('movingHeader').classList.add('true')
      document.getElementById('header').classList.add('true')
      document.getElementById('menuBtn').classList.add('true')
      document.getElementById('wrap').classList.add('true')
      var generalWrap = document.getElementById('wrap')
      generalWrap.classList.add('true')
    },
    closeMenu () { // cl0se the menu
      this.isShowing = false
      menuTransitions.closeMenu()
    },
    closeMenu2 () { // cl0se the menu
      // console.log(document.getElementById('wrap').classList)
      if (document.getElementById('wrap').classList.contains('flock')) {
        this.isShowing = false
        this.openMenu()
        setTimeout(function () {
          menuTransitions.closeMenu()
        }, 750)
      }
    },
    openContact (done) { // open the contact details within menu
      var headerOpen = document.getElementById('movingHeader')
      // var appWrapper = document.body
      if (headerOpen.classList.contains('true')) { // check if head is already open
        // console.log('opened already')
        // var bodyStyle = appWrapper.style.overflow
        // console.log(bodyStyle)
        /* if (bodyStyle === 'hidden') {
          appWrapper.style.overflow = 'scroll'
        } else {
          appWrapper.style.overflow = 'hidden'
        } */
        menuTransitions.openContact(done)
      } else {
        // console.log('opening menu now')
        this.openMenu()
        menuTransitions.openContact(done)
      }
    },
    scrollTo (destination) { // scroll to a div position
      this.closeMenu()
      // var pageName = this.$route.name
      // if (destination === 'nutshell') {
      // var appWrapper = document.body
      // appWrapper.style.overflow = 'scroll'
      // this.closeMenu()
      setTimeout(function () {
        var destinationWrap = document.getElementById(destination)
        const options = {
          speed: 1500
        }
        animateScrollTo(destinationWrap, options)
      }, 800)
      // }
    }
  },
  mounted () {
    /* localStorage.setItem('wasVisited', 1)
    if (localStorage.wasVisited !== undefined) {
      console.log('already been heree')
      document.getElementById('popupCovid').classList.remove('open')
    } else {
      console.log('first time')
    } */
    this.mobileDetect()
    // Hide the bsdIcon div until we scroll
    document.getElementById('bsdIcon').style.opacity = 0
    // React to the event in nutshell component which opens contact
    this.$bus.$on('openContact', function (message) {
      console.log('this is the function here')
      document.getElementById('movingHeader').classList.add('true')
      document.getElementById('menuBtn').classList.add('true')
      var generalWrap = document.getElementById('wrap')
      generalWrap.classList.toggle('true')
      menuTransitions.openContact()
      document.getElementById('menuBtn').classList.add('contactOpen')
    })

    this.$bus.$on('openContact2', function (message) {
      // console.log('step 2')
      document.getElementById('movingHeader').classList.add('true')
      document.getElementById('movingHeader').classList.add('contact')
      var generalWrap = document.getElementById('wrap')
      var backBtn = document.getElementById('menuIcon')
      var menuBtn = document.getElementById('menuBtn')
      var headerSec = document.getElementById('header')
      // var innerSlider = document.getElementById('innerSlider')
      headerSec.classList.add('true')
      menuBtn.classList.add('true')
      backBtn.classList.add('back')
      generalWrap.classList.toggle('true')
      menuTransitions.openContact2()
    })

    // Close the menu during the curtain transition instead of below page change
    this.$bus.$on('closing', function (message) {
      this.isShowing = false
      var headerSect = document.getElementById('movingHeader')
      headerSect.classList.remove('true')
      document.getElementById('menuBtn').classList.remove('true')
      var appWrapper = document.body
      var bodyStyle = appWrapper.style.overflow
      if (bodyStyle === 'hidden') {
        // appWrapper.style.overflowY = 'scroll'
      } else if (bodyStyle === 'scroll' && headerSect.classList.contains('true')) {
        appWrapper.style.overflow = 'hidden'
      }
    })

    this.$bus.$on('bsdLogo', function (message) {
      // console.log(message)
      var bsdColour = Object.values(message)
      // console.log(Object.values(bsdColour))
      var bsdIcon = document.getElementsByClassName('icon')
      for (var a = 0; a < bsdIcon.length; a++) {
        bsdIcon[a].classList.remove('black')
        bsdIcon[a].classList.remove('white')
        bsdIcon[a].classList.add(bsdColour)
      }
    })

    Axios.get(this.$root.$data.site + '/wp-json/wp/v2/pages/65').then(response => {
      this.phone = response.data.acf.bsd_phone_number
      this.email = response.data.acf.bsd_email
      this.address = response.data.acf.bsd_address
      this.facebook = response.data.acf.bsd_facebook
      this.instagram = 'https://instagram.com/' + response.data.acf.bsd_instagram
    }).catch(function (error) {
      console.log(error)
    })
  },
  components: {
    Icon
  }
}
</script>




// WEBPACK FOOTER //
// src/components/global/header.vue